import { ENDPOINTS } from "@/api/application-api";
import { PaginatedResponse } from "@/queries/types";
import { promptLabel } from "@/schemas";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";

export const usePromptLabels = (
  userToken: string,
  workspace_id: number,
  prompt_id?: number,
  page?: number,
) => {
  return useQuery<
    PaginatedResponse<promptLabel.Response[], "prompt_labels", string>
  >(
    [
      ENDPOINTS.prompt_labels(workspace_id),
      userToken,
      workspace_id,
      prompt_id,
      page,
    ],
    () => {
      const url = new URL(ENDPOINTS.prompt_labels(workspace_id));
      url.searchParams.set("workspace_id", workspace_id.toString());
      if (prompt_id) {
        url.searchParams.set("prompt_id", prompt_id.toString());
      }
      if (page) {
        url.searchParams.set("page", page.toString());
      }
      return fetch(url, {
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
  );
};
